// extracted by mini-css-extract-plugin
export default {"page-loader":"PageLoader_page-loader__MkStF","weld-rotate":"PageLoader_weld-rotate__40GtS"};